<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    // CASSIOPEIA
    import { Button, Bubble, Icon, AuctionDownload } from '@smatch/cassiopeia-web-components';

    // PLUGINS
    import { t } from 'svelte-i18n';

    /* EXPORTS --------------------------------------------------------------------------------- */

    export let auctionKey: string = '';

    /* INTERNALS -------------------------------------------------------------------------------- */

    let showUserBubble = false;

    const toggleBubble = (): void => {
        showUserBubble = !showUserBubble;
    };

</script>

{#if Boolean(auctionKey) }

    <Button
        icon = 'download'
        style = 'solid'
        color = 'dark'
        css = 'w-9 !h-9 !px-0 mx-auto block shrink-0'
        on:click = { toggleBubble }
    />

    <Bubble position = 'north-east' css = '-mr-2.5 !w-48' bind:isVisible = { showUserBubble }>

        <AuctionDownload { auctionKey } let:data>

            <!-- TODO: Fix slot types -->
            <!-- eslint-disable @typescript-eslint/no-unsafe-member-access -->

            {#if Array.isArray(data) && data.length > 0}
                <ul class = 's8-download'>
                    {#each data as item}
                        <li>
                            <a href = { item.url } download = { item.name }>
                                <Icon key = 'downloadFile' css = 'h-3.5 mr-1 -top-0.5 relative !inline' />
                                { $t(`global.actions.download_${ item.type }`)}
                            </a>
                        </li>
                    {/each}
                </ul>
            {/if}

            <!-- eslint-enable -->

        </AuctionDownload>

    </Bubble>

{/if}

<style lang="postcss">
    ul.s8-download {
        li {
            &:not(:last-child) {
                @apply mb-2;
            }
        }
    }
</style>